import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImpersonationService} from '../../services/impersonation.service';

@Component({
    selector: 'app-impersonation-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './impersonation-banner.component.html',
})
export class ImpersonationBannerComponent {
    protected readonly impersonationService = inject(ImpersonationService);

    protected endSession(): void {
        this.impersonationService.clearImpersonation();
        window.close();
        // Fallback if browser blocks window.close() (only works for programmatically opened tabs)
        window.location.href = '/login';
    }
}
